import { render, staticRenderFns } from "./CampaignPanel.vue?vue&type=template&id=451661a8&"
import script from "./CampaignPanel.vue?vue&type=script&lang=ts&"
export * from "./CampaignPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports